import { forwardRef } from 'react';

import { IconProps } from './icon';

export const WarningOctagonIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path fill="currentColor" d="M11 13C11 13.5523 10.5523 14 10 14C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12C10.5523 12 11 12.4477 11 13Z" />
      <path
        fill="currentColor"
        d="M10 6C9.58579 6 9.25 6.33579 9.25 6.75V10.25C9.25 10.6642 9.58579 11 10 11C10.4142 11 10.75 10.6642 10.75 10.25V6.75C10.75 6.33579 10.4142 6 10 6Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.72183 3C7.324 3 6.94247 3.15803 6.66117 3.43934L3.43934 6.66117C3.15804 6.94247 3 7.324 3 7.72182V12.2782C3 12.676 3.15803 13.0575 3.43934 13.3388L6.66117 16.5607C6.94247 16.842 7.324 17 7.72182 17H12.2782C12.676 17 13.0575 16.842 13.3388 16.5607L16.5607 13.3388C16.842 13.0575 17 12.676 17 12.2782V7.72183C17 7.324 16.842 6.94247 16.5607 6.66117L13.3388 3.43934C13.0575 3.15804 12.676 3 12.2782 3H7.72183ZM12.2782 4.5H7.72183L4.5 7.72182L4.5 12.2782L7.72183 15.5L12.2782 15.5L15.5 12.2782L15.5 7.72183L12.2782 4.5Z"
      />
    </svg>
  );
});

export default WarningOctagonIcon;
